/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An eligible destination for an outlet withdrawal
 */
export type WithdrawalDestinationRecord = {
    accountName?: string;
    accountNumber?: string;
    bankName?: string;
    destinationType?: WithdrawalDestinationRecord.destinationType;
    /**
     * Identifies this destination on the fee and withdrawal calls
     */
    id?: string;
    /**
     * Rendered as-is by the client
     */
    label?: string;
};

export namespace WithdrawalDestinationRecord {

    export enum destinationType {
        MAIN_WALLET = 'MAIN_WALLET',
        LINKED_ACCOUNT = 'LINKED_ACCOUNT',
    }


}

